angular.module('rjmNg.directives').directive "importApiConnectionEditor", [
  () ->
    restrict: "E"
    templateUrl: "connectionEditors/importApi.html"
    replace: true
    scope: {}
    controller: [
      "$scope"
      "$routeParams"
      "ConnectionMeta"
      "app"
      "$clientAppUrl"
      "ImportApi"
      "$url"
      (
        $scope
        $routeParams
        ConnectionMeta
        app
        $clientAppUrl
        ImportApi
        $url
      ) ->

        $scope.connectionsPageUrl = $clientAppUrl('/settings/connection/')

        $scope.clientId = app.getClientId()
        $scope.keyAlreadyGenerated = false
        $scope.saving = false
        $scope.saved = false
        $scope.loading = true
        $scope.loader = $url("/images/loadingIndicator-small.gif")

        if $routeParams.connectionId?
          $scope.connectionId = $routeParams.connectionId
        else
          $scope.connectionId = null

        ImportApiInstance = ImportApi($scope.clientId)

        $scope.loadConnection = (connectionId) ->
          ConnectionMeta(app.getClientId()).connection(connectionId).then(({data}) ->
            $scope.loading = false
            if data.id
              $scope.keyAlreadyGenerated = true
              $scope.model = data
              $scope.connectionId = data.id
              $scope.originalName = data.meta?.name
            )

        if $scope.connectionId?
          $scope.loadConnection($scope.connectionId)
        else
          $scope.loading = false

        $scope.createConnection = () ->
          $scope.saved = false
          $scope.saving = true
          ImportApiInstance.create({ "name": $scope.model.meta.name })
          .then (result) ->
            $scope.loadConnection(result.id)
            $scope.saving = false
            $scope.saved = true
          .catch () ->
            $scope.error = true

        $scope.editConnection = () ->
          $scope.saved = false
          $scope.saving = true
          ImportApiInstance.save({ id: $scope.connectionId, "name": $scope.model.meta.name })
          .then (result) ->
            $scope.loadConnection(result.id)
            $scope.saving = false
            $scope.saved = true
          .catch () ->
            $scope.error = true

    ]

]
